import { Component, Input } from '@angular/core';
import dayjs from 'dayjs';

@Component({
	templateUrl: './journey-appointment-icon.component.html',
	styleUrls: ['./journey-appointment-icon.component.scss'],
	selector: 'journey-appointment-icon',
})
export class JourneyAppointmentIconComponent {
	public _date;
	@Input() status: 'scheduled' | 'suggested' | 'completed';
	@Input() registerBy = null;
	@Input() index: number;
	@Input() type: 'sessions' | 'contents' | 'evaluations' = 'sessions';
	@Input() set date(date) {
		if (!date) {
			this._date = null;
			return;
		}
		let prefix = 'Realizada em';
		if (this.type === 'evaluations') {
			prefix = 'Respondida em';
		} else if (this.type === 'contents') {
			prefix = 'Escutado em';
		}
		const _date = dayjs(date).locale('pt-br');

		this._date = `${prefix} ${_date.format('DD/MM/YYYY')}`;
	}

	get date() {
		if (this.registerBy) {
			return `${this._date} por ${this.registerBy}`;
		}
		return `${this._date}`;
	}
}
